import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Scale, ArrowRight, Megaphone } from "lucide-react";

export const JailCampaignCard = () => (
  <div
    className="relative overflow-hidden rounded-2xl border border-orange-500/30 bg-gradient-to-br from-slate-950 via-slate-900 to-orange-950 shadow-lg"
    data-testid="jail-campaign-card"
  >
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_88%_20%,rgba(234,88,12,0.22),transparent_55%)]" />
    <div className="relative p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6">
      <img
        src="/scdsa-badge.jpg"
        alt="Shelby County Deputy Sheriffs' Association"
        className="flex-shrink-0 w-20 h-20 rounded-full object-cover ring-2 ring-orange-400/60 shadow-lg"
        data-testid="jail-campaign-card-badge"
      />
      <div className="flex-1 min-w-0">
        <div className="inline-flex items-center gap-1.5 text-orange-300 text-xs font-bold uppercase tracking-widest mb-1.5">
          <Megaphone className="w-3.5 h-3.5" /> Public Awareness Campaign · Shelby County
        </div>
        <h3 className="text-xl md:text-2xl font-bold text-white leading-tight">
          Building a Better Shelby County Jail
        </h3>
        <p className="text-sm md:text-base text-slate-300 mt-1.5 max-w-2xl">
          <span className="text-orange-200 font-semibold italic">Safe Deputies. Safe Facilities. Safer Communities.</span>{" "}
          Get the facts on staffing, pay, and conditions at 201 Poplar — and how to take action.
        </p>
      </div>
      <div className="flex-shrink-0">
        <Link to="/building-a-better-jail">
          <Button className="bg-orange-500 hover:bg-orange-400 text-white font-bold w-full md:w-auto" data-testid="jail-campaign-card-cta">
            <Scale className="w-4 h-4 mr-2" /> Get Informed <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  </div>
);

export default JailCampaignCard;
